// AUTO-GENERATED SEED — review before trusting. Rename keys (index→list/detail),
// refine params, confirm caller flags, add opt-in response types.
import { responseType } from '@auctogon/core/api/registry';
import { defineAdminRoute } from './define-admin-route';
// Type-only import (erased at build) — keeps the registry client-bundle-safe.
import type { LocationDto } from '@auctogon/core/schemas/responses/location';

export const locations = {
  id: defineAdminRoute({
      path: '/api/locations/:id',
      params: { id: '' },
      // Response DTO carrier (ADR 027 / BL-855): PUT returns the updated location;
      // the client infers LocationDto with no <T>, and `respond()` type-checks the
      // route against this same declaration. DELETE returns no data payload, so it
      // carries no response marker.
      // BL-1877: same three writers as POST below — Accounting edits and
      // deletes customer addresses on purpose, through `customer.update_documents`.
      methods: {
        PUT: {
          grant: { anyOf: ['customer.update', 'settings.update_auctions', 'customer.update_documents'] },
          tenant: { from: 'record', table: 'location', param: 'id' },
          response: responseType<LocationDto>(),
        },
        DELETE: { grant: { anyOf: ['customer.update', 'settings.update_auctions', 'customer.update_documents'] }, tenant: { from: 'record', table: 'location', param: 'id' } },
      },
    }),
  index: defineAdminRoute({
      path: '/api/locations',
      params: {},
      // GET lists the tenant's locations (bare array envelope); POST returns the
      // created location. Both bound to the shared LocationDto (ADR 027 / BL-855).
      methods: {
        // BL-921: GET accepts optional scope params — customerId ADDS that
        // customer's active locations; currentLocationId includes that row even
        // when archived. Loose by design (values coerced to strings).
        // BL-1833: every role reads addresses — the Cataloger through the item
        // form's location picker, Accounting through the invoice modal and the
        // customer Addresses card.
        GET: {
          grant: { anyOf: ['inventory.read', 'customer.read_limited'] },
          tenant: { from: 'input', field: 'tenantId', in: 'query' },
          response: responseType<LocationDto[]>(),
          // BUG-1038: customerOnly excludes House locations when paired with
          // customerId — used by the customer detail page's Addresses card.
          query: { tenantId: '', customerId: '', currentLocationId: '', customerOnly: false },
        },
        // Written from Settings → Locations (`settings.update_auctions`) and the
        // customer Addresses card. BL-1877 (Michael Lawrie, 2026-10-01): Accounting
        // may create, edit and delete customer addresses on purpose, and
        // `customer.update_documents` (customers.accounting_tab) is the grant that
        // admits it; `customer.update` is Admin's.
        POST: { grant: { anyOf: ['customer.update', 'settings.update_auctions', 'customer.update_documents'] }, tenant: { from: 'input', field: 'tenantId', in: 'body' }, response: responseType<LocationDto>() },
      },
    }),
};
